import { render, staticRenderFns } from "./StatusMandatoShow.vue?vue&type=template&id=41e8b053&scoped=true&"
import script from "./StatusMandatoShow.vue?vue&type=script&lang=js&"
export * from "./StatusMandatoShow.vue?vue&type=script&lang=js&"
import style0 from "./StatusMandatoShow.vue?vue&type=style&index=0&id=41e8b053&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e8b053",
  null
  
)

export default component.exports